import { render, staticRenderFns } from "./ProfileMirNoCard.vue?vue&type=template&id=7fc94d49&scoped=true&"
import script from "./ProfileMirNoCard.vue?vue&type=script&lang=js&"
export * from "./ProfileMirNoCard.vue?vue&type=script&lang=js&"
import style0 from "./ProfileMirNoCard.vue?vue&type=style&index=0&id=7fc94d49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc94d49",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MtArrowLink: require('/home/bitrix/frontend/components/other/MtArrowLink.vue').default,Button: require('/home/bitrix/frontend/components/other/Button.vue').default})
